var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscountJcPart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3780_6636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 0C11.193 0 0 11.193 0 25C0 38.807 11.193 50 25 50C38.807 50 50 38.807 50 25C50 11.193 38.807 0 25 0Z",
    fill: "#71FFA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1587 7.8125V42.1875L17.2743 37.875L21.4446 41.2383L25.7478 37.875L29.8563 41.7922L34.0728 37.875L37.8415 42.1875V7.8125H12.1587Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9805 27.875H18.0156V28.9492H31.9805V27.875Z",
    fill: "#F00000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9805 31.8555H18.0156V32.9297H31.9805V31.8555Z",
    fill: "#F00000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9422 15.3465C23.9422 17.9285 22.3094 19.277 20.525 19.277C18.6453 19.277 17.1641 17.8715 17.1641 15.5551C17.1641 13.3527 18.5117 11.6824 20.6195 11.6824C22.7461 11.6816 23.9422 13.2387 23.9422 15.3465ZM19.3094 15.4785C19.3094 16.7691 19.7453 17.6996 20.5813 17.6996C21.3977 17.6996 21.7961 16.8652 21.7961 15.4785C21.7961 14.2254 21.4547 13.2574 20.5617 13.2574C19.7078 13.2574 19.3094 14.2449 19.3094 15.4785ZM20.6758 24.441L27.7586 11.6816H29.3156L22.2141 24.441H20.6758ZM32.8281 20.473C32.8281 23.0551 31.1953 24.4035 29.4109 24.4035C27.55 24.4035 26.0695 22.998 26.05 20.6816C26.05 18.4793 27.3977 16.809 29.5055 16.809C31.632 16.8082 32.8281 18.3652 32.8281 20.473ZM28.2141 20.6051C28.1953 21.8957 28.6312 22.8262 29.4672 22.8262C30.2836 22.8262 30.682 21.9918 30.682 20.6051C30.682 19.352 30.3594 18.384 29.4672 18.384C28.5937 18.384 28.2141 19.3715 28.2141 20.6051Z",
    fill: "#999999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3780_6636"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountJcPart);
export default __webpack_public_path__ + "static/media/Discount-JC Part.2ee9c4a47ab70e188eb4c7c183c24cbc.svg";
export { ForwardRef as ReactComponent };